module.exports = __webpack_public_path__ + "assets/spaceInvoice.4ceef8a4.svg";